<template>
  <!-- 维护资质文件 -->
  <el-dialog
    :title="title"
    :visible.sync="centerDialogVisible"
    width="73%"
    :before-close="beforeClose"
  >
    <div style="font-size: 13px; margin: 15px 0">
      工程类、物资类、服务类供应商的资质文件都在此页面进行维护
    </div>
    <!--     列表-->
    <div class="multifunctional-table-wrapper-tree">
      <div class="multifunctional-table-wrapper">
        <el-table
          :data="tableDataUPdate"
          row-key="id"
          max-height="450"
          border
          lazy
          class="multifunctional-table"
        >
          <el-table-column label="序号" width="70">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="资质文件名称">
            <template slot-scope="scope">
              <input
                class="requireFileInput"
                type="text"
                v-model="scope.row.aptitudeName"
                placeholder="请输入资质文件名称"
                :maxlength="maxLen"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="true"
                size="mini"
                type="text"
                @click="handleGoAdd(scope.$index, scope.row)"
                >添加
              </el-button>
              <el-button
                v-if="true"
                size="mini"
                type="text"
                :disabled="isOne"
                @click="handleGoDelete(scope.$index, scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="dialogCancelHandle"
        >取消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="dialogSureHandle"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  // qryAptitudeFile,
  maintainAptitudeFile
} from "../api/appSet";

export default {
  name: "baseOpera-qualificationFiledig",
  props: ["index", "qualificationFileList"],
  data() {
    return {
      title: "维护资质文件",
      isFocus: 1,
      centerDialogVisible: true,
      tableDataUPdate: [], //资质文件的复本，不使用复本会与弹框实时更新
      aptitudeName: "",
      placeholder: "",
      maxLen: 15,
      delId: [],
      isOne: false
    };
  },
  created() {
    this.getapitudeFiles();
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    // click any
    beforeClose() {
      this.centerDialogVisible = false;
      this.$emit("fileDialogCancel", this.centerDialogVisible);
    },
    getapitudeFiles() {
      if (this.qualificationFileList && this.qualificationFileList.length > 0) {
        this.tableDataUPdate = JSON.parse(
          JSON.stringify(this.qualificationFileList)
        );
      } else {
        this.tableDataUPdate = [{ aptitudeName: "" }];
      }
      if (this.tableDataUPdate.length == 1) {
        this.isOne = true;
      } else {
        this.isOne = false;
      }
    },
    dialogCancelHandle() {
      this.centerDialogVisible = false;
      this.$emit("fileDialogCancel", this.centerDialogVisible);
    },
    dialogSureHandle() {
      console.log(this.tableDataUPdate);
      // 删除没用的属性
      this.tableDataUPdate = this.tableDataUPdate.filter(function(item) {
        delete item.createTime;
        delete item.updateTime;
        return true;
      });
      const obj = {
        aptitudes: this.tableDataUPdate,
        deleteIds: this.delId,
        isShowLoading: true,
        loadingMessage: "提交中,请稍等..."
      };
      // 资质要求-维护资质文件接口
      maintainAptitudeFile(obj)
        .then(res => {
          // 将弹窗的数据发送给父页面
          this.centerDialogVisible = false;
          this.$emit(
            "fileDialogSure",
            this.index,
            this.centerDialogVisible,
            this.tableDataUPdate
          );
        })
        .catch(err => {});
    },
    handleGoAdd() {
      this.isOne = false;
      // 添加一空行
      this.tableDataUPdate.push({
        aptitudeName: "",
        placeholder: "请输入资质文件名称"
      });
    },
    handleGoDelete(index, row) {
      console.log(row);
      this.tableDataUPdate.splice(index, 1);
      this.delId.push(row.id);
      if (this.tableDataUPdate.length == 1) {
        this.isOne = true;
      } else {
        this.isOne = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  padding: 0 20px 20px;
  overflow: hidden !important;
}

/deep/ .el-dialog__title {
  font-size: 14px;
  font-weight: 600;
}

.requireFileInput {
  width: 288px;
  height: 22px;
  background: #f1f1f1;
  border: none;
  border-radius: 4px;
  color: #4a4a4a;
  font-size: 13px;
  padding: 0 4px;
  line-height: 22px;
}
/deep/
  .multifunctional-table-wrapper
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__body
  tbody
  .el-table__row
  td
  .cell
  .el-button
  span {
  color: #0089ef;
}
/deep/
  .multifunctional-table-wrapper
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__body
  tbody
  .el-table__row
  td
  .cell
  .el-button.is-disabled
  span {
  color: #999;
}
</style>
